let pageInit = false;

let timerId = setTimeout(() => {
  init();
  pageInit = true;
}, 2000);

$(window).on('load', () => {
  if (!pageInit) {
    clearTimeout(timerId);
    init();
  }
});

function init() {
  preloaderHide();
  window.wow.init();
}

function preloaderHide() {
  $('.preloader').addClass('is_hide');
  setTimeout(() => {
    $('.preloader').remove();
  }, 300);
}
